const meta = {
  traces: 'Identify tracing issues',
  metrics: 'Investigate suspicious metrics',
};

export default meta;
